var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.225,
    height: 18.705,
    viewBox: "0 0 10.225 18.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4531",
    "data-name": "Caminho 4531",
    d: "M18.535,10.476H16.218V9.238A1.2,1.2,0,0,0,15.059,8H1.158A1.2,1.2,0,0,0,0,9.238v7.427A1.2,1.2,0,0,0,1.158,17.9h13.9a1.2,1.2,0,0,0,1.158-1.238V15.427h2.317ZM13.9,15.427H9.267V10.476H13.9Z",
    transform: "matrix(-0.017, -1, 1, -0.017, -7.675, 18.844)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.e6b3235e.svg";
export { ForwardRef as ReactComponent };